import React, { Component } from 'react';
import { Modal, Button, Tooltip } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import TableC from '../../basicElement/TableC';

class FileLogModal extends Component {
    state = {
        data: [],
        visible: false,
        loading: false,
        exportLoading: false,
        pagination:{
            current:1,
            pageSize:10
        },
    }

    show = () => {
        this.setState({
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            data: [],
            visible: false,
        });
    }

    loadData = () => {
        const { pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.deptFile.queryFileLog,
            data: {
                curUserId: sessionStorage.userId,
                offset: current,
                limit: pageSize,
            },
            dataType: 'json',
            doneResult: res => {
                const { departmentFileLogs } = res;
                pagination.total = departmentFileLogs && departmentFileLogs.totalCount || 0;
                this.setState({
                    data: departmentFileLogs && departmentFileLogs.datas || [],
                    loading: false,
                    pagination,
                })
            }
        };
        $.sendRequest(options);
    }

    exportLog = () => {
        this.setState({ exportLoading: true });
        const options = {
            method: 'POST',
            url: API_URL.deptFile.exportFileLog,
            data: {},
            dataType: 'json',
            doneResult: res => {
                this.setState({ exportLoading: false });
                if (res.success) {
                    Modal.success({ title: '调用成功', content: res.success });
                }
            },
            failResult: () => {
                this.setState({ exportLoading: false });
            }
        };
        $.sendRequest(options);
    }
    handleTableChange = (pagination) => {
        this.setState({pagination:pagination.pagination},() => {
            this.loadData();
        })
    }
        
    getColumns = () => {
        const columns = [{
            title: '操作目录',
            dataIndex: 'fileCatalog',
            key: 'fileCatalog',
            width: 120,
            render: (text) => (
                <Tooltip title={text}>
                    <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{text}</div>
                </Tooltip>
            ),
        }, {
            title: '操作时间',
            dataIndex: 'operateTime',
            key: 'operateTime',
            width: 120,
        }, {
            title: '操作人',
            dataIndex: 'operateUser',
            key: 'operateUser',
            width: 120,
        }, {
            title: '操作内容',
            dataIndex: 'operateTypeShow',
            key: 'operateTypeShow',
            width: 120,
        }, {
            title: '操作文件/文件夹',
            dataIndex: 'operateFile',
            key: 'operateFile',
            width: 120,
            render: (text) => (
                <Tooltip title={text}>
                    <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{text}</div>
                </Tooltip>
            ),
        }];
        return columns
    } 

    render() {
        const { visible, loading, exportLoading, data, pagination } = this.state;
        return (
            <Modal
                title="操作日志"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                maskClosable={false}
                width="1100px"
                bodyStyle={{ maxHeight: 600 }}
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <div className="cont-cont contract-record" style={{margin: 20}}>
                    <div>
                        <div style={{ marginBottom: 12, textAlign: 'right' }}>
                            <Button type="primary" loading={exportLoading} onClick={this.exportLog}>导出日志</Button>
                        </div>
                        <TableC
                            rowKey={'id'}
                            data={data}
                            loading={loading}
                            pagination={pagination}
                            scroll={{ x: 300, y: 400 }}
                            columns={this.getColumns()}
                            onChange={this.handleTableChange}
                        />
                        <div style={{ position: 'relative', top: -1, borderTop: '1px solid #e4e4e4' }} />
                    </div>
                </div>
            </Modal>
        );
    }
}

export default FileLogModal;


// WEBPACK FOOTER //
// ./src/components/documentManagement/departmentalDocuments/FileLogModal.js